import sanitizeHtml from "sanitize-html";

import { convertPlainTextToParagraphs } from "@/common/helpers/convertPlainTextToParagraphs";

const LEXICAL_FORMAT_CLASSES = ["lxcl-bold", "lxcl-italic", "lxcl-underline", "lxcl-strikethrough"];

const MISSION_SANITIZE_OPTIONS: sanitizeHtml.IOptions = {
  allowedTags: ["p", "br", "strong", "b", "em", "i", "u", "s", "a", "ul", "ol", "li", "span", "sub", "sup", "img"],
  allowedAttributes: {
    a: ["href", "target", "rel"],
    img: ["src", "alt", "style"],
    p: ["style"],
    li: ["style"],
    span: ["style", "class"],
  },
  allowedClasses: {
    span: LEXICAL_FORMAT_CLASSES,
  },
  allowedStyles: {
    "*": {
      color: [/^#[0-9a-fA-F]{3,6}$/, /^rgb\(\d{1,3},\s*\d{1,3},\s*\d{1,3}\)$/],
      "text-align": [/^(left|right|center|justify)$/],
      "margin-left": [/^\d+(\.\d+)?px$/],
      "padding-left": [/^\d+(\.\d+)?px$/],
    },
    img: {
      width: [/^\d+(\.\d+)?(px|%)$/],
    },
  },
  allowedSchemes: ["https", "http", "mailto"],
  allowedSchemesByTag: {
    img: ["https"],
  },
};

export const getMissionHtml = (description: string | null | undefined): string | null => {
  if (!description) {
    return null;
  }

  const html = convertPlainTextToParagraphs(description.replace(/^LXCL:/, ""));
  return sanitizeHtml(html, MISSION_SANITIZE_OPTIONS).trim() || null;
};
